import { globalSettingsIssueFieldsManagementRouteEntryPoint } from '@jira/admin-pages__fields-page/src/globalSettingsIssueFieldsManagementRouteEntryPoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsIssueFieldsManagementRoute } from '@atlassian/jira-router-routes-admin-pages-fields-routes/src/globalSettingsIssueFieldsManagementRoute.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';

const globalSettingsIssueFieldsManagementEntryPointPage = createPageEntryPoint({
	main: globalSettingsIssueFieldsManagementRouteEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

export const globalSettingsIssueFieldsManagementRouteEntry = createEntry(
	globalSettingsIssueFieldsManagementRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.fields',
		component: ErrorPagesNotFound,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},

		canTransitionIn: () =>
			expValEquals('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false),

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		entryPoint() {
			if (
				expValEquals('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false)
			) {
				return globalSettingsIssueFieldsManagementEntryPointPage;
			}
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-fields-entries/src/globalSettingsIssueFieldsManagementRouteEntry.tsx',
				whichExportToUse: 'globalSettingsIssueFieldsManagementRouteEntry',
			},

			enabled: true,
		},
	}),
);
